// import YXTBIZ from 'yxt-biz-pc'

const config = {};

export const setApiConfig = (c) => {
  Object.assign(config, c);
};

function getAuditApi() {
  try {
    if (!config.auditCenterApi && window.YXTBIZ) {
      // eslint-disable-next-line no-undef
      config.auditCenterApi = YXTBIZ.Api.create({
        // eslint-disable-next-line no-undef
        baseURL: `${feConfig.common.apiBaseUrl}audit/`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          source: 501 // 参照yxt-biz-pc 写死
        }
      });
    }
    return config.auditCenterApi;
  } catch (e) {
    // eslint-disable-next-line
    new Error(`审核中心API没有配置; ${e.message}`);
  }
}

export const getAreas = () => getAuditApi().get('regions/tree');

export const getAuditTemplateInfo = (projId, tmplCode) => getAuditApi().get(`/audittmplinfo/detail/${projId}/${tmplCode}`);
/**
 * 新增审核模板基础信息
 * @param {*} data
 * @returns
 */
export const putAuditTemplateInfo = (projId, tmplCode, data) => getAuditApi().put(`/audittmplinfo/project/edit/${projId}/${tmplCode}`, data);
/**
 * 新增审核模板基础信息
 * @param {*} data
 * @returns
 */
export const postAuditTemplateInfo = (data) => getAuditApi().post('/audittmplinfo/project/save/', data);

// 根据审核模板id获取审核角色
export const getAuditRoleByCode = (tmplCode) => getAuditApi().get(`/audit/role/getbytmplid/${tmplCode}`);
